import withStyles from '@mui/styles/withStyles';
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

// Styling of the table (directly used in table as "StyledTableCell" and "StyledTableRow")
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.table.primary.header.backgroundColor,
        color: theme.palette.table.primary.header.color,
        fontWeight: theme.palette.table.primary.header.fontWeight,
        fontSize: theme.palette.table.primary.header.fontSize
    },
    body: {
        fontSize: theme.palette.table.primary.body.fontSize,
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


export {StyledTableCell, StyledTableRow};